// eslint-disable-next-line import/default
import dayjs from 'dayjs';

// eslint-disable-next-line import/default
import customParseFormat from 'dayjs/plugin/customParseFormat';

// eslint-disable-next-line
dayjs.extend(customParseFormat);

export const today = dayjs();
export const timeFormat = 'HH:mm';
export const dateFormat = 'DD.MM.YYYY';
export const dateFormatInput = 'dd.MM.yyyy'; //format for date-fns
export const dateFormatAPI = 'YYYY-MM-DD';
export const dateTimeFormat = 'DD.MM.YYYY HH:mm';
export const dateTimeFormatInput = 'dd.MM.yyyy HH:mm';
export const dateTimeFormatAPI = 'YYYY-MM-DD HH:mm';

export const format = (date?: Date | string, format?: string, inputFormat?: string): string =>
  dayjs(date, inputFormat).format(format || dateFormat);

export const toISO = (date: Date | string): string => new Date(date).toISOString();
export const getYear = (date: Date | string): string => dayjs(date).format('YYYY');
export const getMonth = (date: Date | string): string => dayjs(date).format('MMM');
export const getFullMonth = (date: Date | string): string => dayjs(date).format('MMMM');
export const getDay = (date: Date | string): string => dayjs(date).format('D');
export const getTime = (date: Date | string): string => dayjs(date).format('HH:mm');

export const monthsSince = (date: Date | string): number => dayjs().diff(date, 'month');

export const isAfter = (date: Date | string): boolean => dayjs().isAfter(date);
export const isBefore = (date: Date | string): boolean => dayjs().isBefore(date);
export const add = (count: number): dayjs.Dayjs => dayjs().add(count, 'day');

export const tomorrow = dayjs().add(1, 'day');
export const yesterday = dayjs().subtract(1, 'day');

export const isFeature = (date: Date | string, inputFormat?: string): boolean => {
  return dayjs(date, inputFormat) > dayjs();
};

export const getAPIDateFormat = (date: string): string => {
  const data = date.split(' ');

  return `${data[0].split('.').reverse().join('-')}${data.length > 1 ? ` ${data[1]}` : ``}`;
};
